// components/NXTLVLLoader.jsx
import React from 'react';
import { motion } from 'framer-motion';
import './NXTLVLLoader.css';
import logo from './logo.svg';

const NXTLVLLoader = () => {
  return (
    <div className="nxtlvl-loader">
      <motion.div
        className="nxtlvl-logo"
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 0.6, ease: 'linear' }}
      >
<img src={logo} alt="NXTLVL Logo" />
      </motion.div>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: [0, 1, 0] }}
        transition={{ duration: 1, repeat: Infinity }}
      >
        Loading NXTLVL...
      </motion.p>
    </div>
  );
};

export default NXTLVLLoader;